<script>
import dayjs from "dayjs";
import { t } from "@/i18n";
import { object } from "@amcharts/amcharts4/core";

export default {
  name: "FaultReportView",
  props: {
    imageName: {
      type: String,
      default: "fault-report",
    },
    faultType: {
      type: String,
      default: "gear_failure",
    },
    createdAt: {
      type: String,
      default: "2022-12-12T12:12:21.000Z",
    },
    pointPath: {
      type: String,
      default: "a>b>c",
    },
    severity: {
      type: String,
      default: "hazard",
    },
    name: {
      type: Object,
      default:()=>{return {
        tr: null,
        en: null,
        de: null,
        ru: null,
        zh: null,
        zhTw: null
      }}
    },
    info: {
      description: [],
      suggestions: []
    },
    showDownload: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  methods: {
    download() {
      this.$emit("download")
    },
    formatDate(dateArray) {
      return dayjs(dateArray).format("DD.MM.YYYY");
    },
  },
  computed: {
    displayName() {
      return this.name[this.$i18n.locale]
    },
    fault_name() {
      return this.faultType;
    },
    description() {
      return this.info ? this.info.description[this.$i18n.locale]:"";
    },
    severityImage() {
      return `https://sensemore-public-contents.s3.eu-central-1.amazonaws.com/resfaultreport/severity/${this.severity}.png\?test\=qwqerqw`;
    },
    image() {
      const imageName = this.imageName.endsWith(".png")
        ? this.imageName
        : `${this.imageName}.png`;
      return `https://sensemore-public-contents.s3.eu-central-1.amazonaws.com/resfaultreport/${imageName}\?test\=qwqerqw`;
    },
    predictionTimeToStop() {
      if (this.severity === "critical") {
        return this.$t("faultReport.predictionTimeStopInOneMonth");
      } else if (this.severity === "hazard") {
        return this.$t("faultReport.predictionTimeStopInTwoMonth");
      } else if (this.severity === "attention") {
        return this.$t("faultReport.predictionTimeStopInThreeMonth");
      }
      return this.severity;
    },

    suggestions() {
      return this.info.suggestions
        .map((suggestion) => suggestion.suggestion[this.$i18n.locale])
        .sort((a, b) => (a.order < b.order ? -1 : 1));
    },
  },
};
</script>

<template>
  <div style="display: flex; height: auto; width: 100%" class="detection-report">
    <div class="faultreport-description">
      <div style="width: auto; margin-top: 67px; height: 45px">
        <img style="height: 100%" class="sensemore-logo" src="images/faultTypes/sensemore-logo.png" />
      </div>
      <div style="width: 100%">
        <p style="
            color:black;
            letter-spacing: 0.12em;
            line-height: 29px;
            letter-spacing: 0.12em;
            --para-spacing: 0;
            text-transform: uppercase;
            font-style: normal;
            font-size: 20px;
            font-weight: 600;
            padding: 10px;
            border: 3px solid black;
            text-align: center;
          ">
          {{ $t("faultReport.title") }}
        </p>
        <p style="
            color:#b1b1b1;
            font-weight: 400;
            font-style: normal;
            line-height: 16px;
            letter-spacing:0.05em;
            font-size: 12px;
          ">
          {{ pointPath.replace('/', '>') }}
        </p>
        <p style="
            color:#b1b1b1;
            font-weight: 400;
            font-style: normal;
            line-height: 5px;
            letter-spacing:0.05em;  
            font-size: 12px;
          ">
          {{ formatDate(createdAt) }}
        </p>
      </div>
      <div style="align-self: center; display: flex; flex-direction: column">
        <img v-bind:src="image" 
        style="
            align-self: center;
            width: 100%;;
            height: 200px;
            max-width:400px;
            object-fit: contain;
            text-align: center;
          " />
        <div style="
            font-weight: 700;
            font-size: 16px;
            font-size: 18.6667px;
            font-style: normal;
            text-align: center; 
            color:#1F1F1F;
          ">
          {{ displayName }}
        </div>
        <p v-html="description" style="font-weight: 400; font-style: normal; font-size: 12px; color:#595959;">
        </p>
      </div>
      <div style="width: 100%; margin-bottom: 20px; height: 75px">
        <p style="
            color:#b1b1b1;
            font-weight: 200;
            font-style: normal;
            font-size: 12px;
            bottom: 15px;
            position: absolute;
          ">
          {{ $t("faultReport.contactus") }}
          <br />
          hello@sensemore.io
        </p>
      </div>
    </div>
    <div class="faultreport-suggestions">
      <div class="buttons">
        <span style="font-size: 12px">
          <el-button style="margin-top: 10px; margin-right: 10px;" size="mini" @click="download()"
            v-show="this.showDownload">{{
                $t("common.download")
            }}</el-button>
        </span>

      </div>
      <div style="
          width: 100%;
          margin-bottom: 40px;
          margin-top: 70px;
          text-align: center;
        ">
        <img :src="severityImage" width="155" height="83" style="object-fit: contain;" />
        <div style="font-size: 12px; font-weight:600;">
          <p style="color:#595959; text-align: center;">{{ predictionTimeToStop }}</p>
        </div>
      </div>
      <div style="
          font-weight: 400;
          width: 100%;
          text-align: center;
          font-size: 16px;
          padding-top: 5px;
          padding-bottom: 5px;
          color:#b1b1b1;
        ">
        {{ $t("faultNames.suggestionstitle") }}
      </div>
      <div v-for="suggestion of suggestions" v-bind:key="suggestion" class="suggestion-container" style="
          width: 100%;
          flex-direction: column;
          display: flex;
        ">
        <div class="suggestion-item-container">
          <div class="suggestion-item-padding">
            <div class="suggestion-item-exclamation">!</div>
            <p style="flex: 1;">
              {{ suggestion }}
            </p>
          </div>
        </div>
      </div>
      <div style="height: 70px"></div>
    </div>
  </div>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');

.detection-report {
  font-family: 'Montserrat', sans-serif !important;
}

.buttons {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.logo {
  margin: auto;
  background-position: center;
  width: 245px;
  background-size: cover;
  flex: 1;
  height: 46px;
}

.sensemore-logo {
  width: 100%;
  max-width: 188px;
  object-fit: contain;
  float: left;
}

.faultreport-description {
  display: flex;
  flex: 1;
  position: relative;
  background-color: #eeeeee;
  flex-direction: column;
  padding-left: 60px;
  padding-right: 60px;
  width: 50%;
  box-sizing: border-box;
  max-width: 555px;
}

.faultreport-suggestions {
  flex: 1;
  position: relative;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  padding-left: 60px;
  padding-right: 60px;
  width: 50%;
  max-width: 555px;
}

.suggestion-item-container {
  background-color: #eeeeee;
  width: 100%;
  min-height: 80px;
  display: flex;
  font-size: 14px;
  margin-top: 10px;
}

.suggestion-item-padding {
  padding-right: 10px;
  align-items: center;
  display: flex;
}

.suggestion-item-padding p {
  margin-inline-start: 0px !important;
}

p {
  margin-left: 0 !important;
  text-align: left;
  word-break: break-word;
}

.suggestion-item-exclamation {
  width: 30px;
  font-size: 40px;
  text-align: center;
  margin: 0 auto;

}

@media screen and (min-width: 800px) {
  body {
    /* background-color: lavender; */
  }
}
</style>
